import React from 'react'
import {Layout, Menu, Divider, Button, Typography} from 'antd';
import 'antd/dist/antd.css';
import {
    MenuUnfoldOutlined,
    SettingOutlined,
    UsergroupAddOutlined,
    FileZipOutlined,
    PicRightOutlined, ExclamationCircleOutlined, NotificationOutlined
} from '@ant-design/icons';
import {Auth, UserInfo} from '@q4us-sw/q4us-ui'

import Dashboard from '../component/Dashboard'
import Register from '../component/Register'
import {Schedules} from '../component/Schedules'
import {EMList} from "../component/EMList";
import {Info} from "../component/Info";
import {OrderInfo} from "../component/OrderInfo";
import {OrderReturn} from "../component/OrderReturn";
import {OrderDiscount} from "../component/OrderDiscount";
import {RefTable} from '../component/RefTable'
import {HS6P} from '../component/reference/HS6P'
import {Enum} from '../component/Enum'
import {PaginatedAuditTrail} from "../component/AuditTrailPaginated";
import {CustomsDutyRates} from "../component/reference/CustomsDutyRates";
import {CountryVatRates} from "../component/reference/CountryVatRates";
import {HistoricCountryVATData} from "../component/reference/HistoricCountryVATData"
import {SpecialTerritories} from "../component/reference/SpecialTerritories";
import {HS6PSubcontractorInfo} from '../component/HS6PSubcontractorInfo'
import {PostalOperator} from '../component/PostalOperator'
import {Customs} from "../component/reference/Customs"
import {DPOSpecialArrangement} from '../component/reference/DPOSpecialArrangement'
import {DailyExchangeRates} from '../component/DailyExchangeRates'
import {AnnualExchangeRates} from '../component/AnnualExchangeRates'
import {FeeClasses} from '../component/FeeClasses'
import {GDPRDocuments} from "../component/reference/GDPRDocuments";
import {ReportingDataSecurityAgreements} from "../component/reference/ReportingDataSecurityAgreements";
import {EMDashboardCobrand} from "../component/EMDashboardCobrand";
import {withAuthentication} from '@q4us-sw/q4us-ui'

import {updateSDRRate} from '../component/ExchangeRateFuncs'
import {MonthlyLastDayExchangeRates} from '../component/MonthlyLastDayExchangeRates'
import {RiskManagement} from "../component/RiskManagement";
import {ApplicationView} from '../component/Applications'
import logo from '../assets/img/logo.png'

import {useHistory, useLocation} from 'react-router-dom'
import {Route} from 'react-router-dom'
import {Reports} from "../component/Reports";
import {EMVATFiscalCorrection} from "../component/reference/EMVATFiscalCorrection"
import {VATCorrectionTable, VATCorrectionTableSchema} from "../utils/constants"
import {UserManagement} from "../component/UserManagement";
import {OperatorUserManagement} from "../component/OperatorUserManagement";
import '../styles/MainView.css'
import {LandingView} from "./LandingView";
import {Invitations} from '../component/reference/Invitations'
import {
    ShopOutlined,
    MailOutlined,
    ContainerOutlined,
    TableOutlined,
    EuroCircleOutlined,
    ThunderboltOutlined,SwapOutlined,
    SolutionOutlined,CreditCardOutlined,
    FileDoneOutlined,FundOutlined,FileSearchOutlined,
    FundViewOutlined,ScheduleOutlined,PoweroffOutlined,
    IdcardOutlined,NodeIndexOutlined,ToolOutlined, HddOutlined, WindowsOutlined
} from '@ant-design/icons'
import {MassPostSaleLog} from "../component/MassPostSaleLog";
import { MassPostSaleWithoutLC } from  "../component/MassPostSaleWithoutLCLog"
import {InvoiceSettings} from "../component/InvoiceSettings";
import {ErrorLogs} from '../component/ErrorLogs'
import {GeneralContractDocuments} from "../component/GeneralContractDocuments";
import {
    ExchangeRatesNonEU
} from "../component/reference/ExchangeRatesNonEU";
import {NotificationSubscribers} from "../component/NotificationSubscribers";
import {NotificationTypes} from "../component/NotificationTypes";
import {IntermediaryInformation} from "../component/IntermediaryInformation";
import {NotificationSettings} from "../component/NotificationSettings";
/*
* Refernce Data Imports
* */
import {Country} from "../component/reference/Country"
import {Currency} from "../component/reference/Currency"
import {SDRExchangeRate} from "../component/reference/SDRExchangeRate";
import {NonEUVatRate} from "../component/NonEUVatRates";
import {VatRegistration} from "../component/reference/VatRegistrations";
import {Checkout} from "../component/reference/Checkout";
import {Courier} from "../component/reference/Courier";
import {AutoActiveFeeClasses} from "../component/reference/AutoActiveFeeClasses";
import {SalesType} from "../component/reference/SalesType";
import {AnnualFees} from "../component/reference/EMAnnualFee";
import {ReportingFeeClasses} from "../component/reference/ReportingFees";
import {InvoicingFees} from "../component/reference/InvoicingFees";
import {EASOSSIntermediaryNumbers} from "../component/reference/EASOSSIntermediaryNumbers";
import {EMPlatform} from "../component/reference/EMPlatform";
import {InvoiceListView} from "../component/InvoiceListView";
import {EMVATReportFiscalView} from "../component/EMVATReportFiscalView";
import {CustomsDutyRatesNonEU} from "../component/reference/CustomsDutyRatesNonEU";
import {CountryGroups} from "../component/reference/CountryGroups";
import {EMVATFiscalReportListView, EMVATFiscalReportListViewV1} from "../component/EMVATFiscalReportListView";
import {MonthlyExchangeRatesGBP} from "../component/MonthlyExchangeRatesGBP";
import DirectMessage from "../em/DirectMessage";
import AddMessage from "../em/AddMessage";
//import {ErrorNotificationTypes} from "../component/reference/ErrorNotificationTypes";
//import {NotificationSubscribers} from "../component/reference/NotificationSubscribers";

const CC_URL = 'https://cc.easproject.com';
const CC_DEV_URL = 'https://cc-dev.easproject.com';

const CC_EM = '/em-management';
const CC_INVOICE = '/invoice-management';
const CC_ORDER  = '/order-management?order_status=payment_verified';
const CC_VAT_CORRECTION = '/vat-corrections?approval_status_for_filter=PENDING';
const CC_VAT_REPORTS = '/fiscal-reports?payment_handling_mode=indirect&timestamp=fiscal_report_range'


const jwt = require('jsonwebtoken');

const MainViewImpl = ({title, children, footer}) => {
    const {Content, Sider} = Layout;
    const [opt, setOpt] = React.useState({collapse: false})
    const {SubMenu} = Menu;
    const history = useHistory()
    const location = useLocation()
    const [selectedMenu, setSelectedMenu] = React.useState([])

    const EM_MANAGEMENT_URL = window.location.hostname.includes('internal1') ? `${CC_DEV_URL}${CC_EM}` : `${CC_URL}${CC_EM}`;
    const INVOICE_MANAGEMENT_URL = window.location.hostname.includes('internal1') ? `${CC_DEV_URL}${CC_INVOICE}` : `${CC_URL}${CC_INVOICE}`;
    const ORDER_MANAGEMENT_URL = window.location.hostname.includes('internal1') ? `${CC_DEV_URL}${CC_ORDER}` : `${CC_URL}${CC_ORDER}`;
    const VAT_CORRECTION_MANAGEMENT_URL = window.location.hostname.includes('internal1') ? `${CC_DEV_URL}${CC_VAT_CORRECTION}` : `${CC_URL}${CC_VAT_CORRECTION}`;
    const VAT_REPORTS_MANAGEMENT_URL = window.location.hostname.includes('internal1') ? `${CC_DEV_URL}${CC_VAT_REPORTS}` : `${CC_URL}${CC_VAT_REPORTS}`;

    React.useEffect(() => {
        const [path] = selectedMenu;
        if (path !== location.pathname) {
            setSelectedMenu([location.pathname])
        }
        const {exp} = jwt.decode(Auth.token)
        if (exp * 1000 < Date.now()) {
            Auth.signOut();
        }
    }, [location])

    React.useEffect(() => {
        history.push('/view/dashboard')
    },[])

    return <React.Fragment>
        <Layout style={{height: "100vh"}}>
            <Sider
                theme="light"
                collapsedWidth={75}
                style={{overflowY: "auto"}}
                collapsible collapsed={opt.collapse} onCollapse={(collapse => setOpt({...opt, collapse}))}
            >
                <div className={`main-wrapper`}>
                    <div className={`main-header`}>
                        <img style={{maxHeight: 100}} src={logo}/>
                    </div>
                    <div className={`main-user-info`}>
                        {(!opt.collapse) && <span className={`main-username`}>{Auth.getUser()}</span>}
                        <Button type={"primary"} className={`main-sign-out`} danger icon={<PoweroffOutlined/>} onClick={()=>Auth.signOut()}/>
                    </div>
                    <div className={`main-menu`}>
                        <Menu
                            theme="light"
                            mode="inline"
                            selectedKeys={selectedMenu}
                            onSelect={({key}) => {
                                if (key === "/view/em-manager") {
                                    window.open(EM_MANAGEMENT_URL, "_blank", "noopener,noreferrer");
                                    return;
                                }
                                if (key === "/view/invoice_list_view") {
                                    window.open(INVOICE_MANAGEMENT_URL, "_blank", "noopener,noreferrer");
                                    return;
                                }
                                if (key === "/view/order_info") {
                                    window.open(ORDER_MANAGEMENT_URL, "_blank", "noopener,noreferrer");
                                    return;
                                }
                                if (key === "/view/order_return") {
                                    window.open(ORDER_MANAGEMENT_URL, "_blank", "noopener,noreferrer");
                                    return;
                                }
                                   if (key === "/view/order_discount") {
                                    window.open(ORDER_MANAGEMENT_URL, "_blank", "noopener,noreferrer");
                                    return;
                                }
                                if (key === "/view/vat_correction") {
                                    window.open(VAT_CORRECTION_MANAGEMENT_URL, "_blank", "noopener,noreferrer");
                                    return;
                                }
                                if (key === "/view/emvat_report_fiscal_view") {
                                    window.open(VAT_REPORTS_MANAGEMENT_URL, "_blank", "noopener,noreferrer");
                                    return;
                                }

                                history.push(key)
                            }}
                        >
                            <Menu.Item key={"/view/dashboard"} className="menu-bar-button" icon={<WindowsOutlined size={75}/>}>Dashboard</Menu.Item>,
                            <SubMenu title={"E Merchants"} mode="vertical" icon={<ShopOutlined/>}>
                                <Menu.Item key="/view/register" icon={<ContainerOutlined/>}>
                                    Register
                                </Menu.Item>
                                <Menu.Item key={"/view/em-manager"} className="menu-bar-button" icon={<ShopOutlined/>}>
                                    EM Management
                                </Menu.Item>
                            </SubMenu>

                            <Divider style={{margin: 5}}/>
                            <Menu.Item key="/view/vat_correction" icon={<EuroCircleOutlined/>}>
                                EM VAT Corrections
                            </Menu.Item>
                            <Divider style={{margin: 5}}/>
                            <Menu.Item key="/view/reports" icon={<FundViewOutlined/>}>
                                Reports
                            </Menu.Item>
                            <Divider style={{margin: 5}}/>
                            <SubMenu icon={<EuroCircleOutlined/>} title="Order Management" mode="vertical">
                                <Menu.Item key="/view/order_info">Orders List</Menu.Item>
                                <Menu.Item key="/view/order_return">Order Returns</Menu.Item>
                                <Menu.Item key="/view/order_discount">Order Discounts</Menu.Item>
                            </SubMenu>
                            <Divider style={{margin: 5}}/>
                            <Menu.Item key="/view/invoice_list_view" icon={<FundViewOutlined/>}>
                                Invoice Management
                            </Menu.Item>
                            <Divider style={{margin: 5}}/>
                            <Menu.Item key="/view/emvat_report_fiscal_view" icon={<FundViewOutlined/>}>
                                VAT Report Management
                            </Menu.Item>
                            <Divider style={{margin: 5}}/>
                            <SubMenu icon={<UsergroupAddOutlined/>} title="User Management" mode="vertical">
                                {/* <Menu.Item key="/view/user_management/dashboard" icon={<IdcardOutlined />}>
                                    Dashboard
                                </Menu.Item> */}
                                <Menu.Item key="/view/user_management/operator" icon={<IdcardOutlined />}>
                                    Operator
                                </Menu.Item>
                            </SubMenu>

                            <Menu.Item key="/view/risk_management" icon={<ThunderboltOutlined />}>
                                Risk Management
                            </Menu.Item>
                            <Divider style={{margin: 5}}/>
                            <SubMenu icon={<SolutionOutlined />} title="Reference Tables" mode="vertical">
                                <SubMenu title={"General"} icon={<SettingOutlined/>}>
                                    <Menu.Item key="/view/ref_sales_type">Sale Types</Menu.Item>
                                    <Menu.Item key="/view/ref_checkouts">Checkout Systems</Menu.Item>
                                    <Menu.Item key="/view/gdpr_documents">GDPR Documents</Menu.Item>
                                    <Menu.Item key="/view/data_security_agreements">Reporting Data Security Agreements</Menu.Item>
                                    <Menu.Item key="/view/em_platform">Integration Platforms</Menu.Item>
                                    <Menu.Item key="/view/ref_country">Countries</Menu.Item>
                                    <Menu.Item key="/view/ref_currency">Currencies</Menu.Item>
                                    <SubMenu title={"Delivery Options"}>
                                        <Menu.Item key="/view/ref_po">Postal Operators</Menu.Item>
                                        <Menu.Item key="/view/ref_courier">Couriers</Menu.Item>
                                    </SubMenu>
                                </SubMenu> 

                                <SubMenu title="Exchange Rates" mode="vertical" icon={<SwapOutlined />}>
                                    <Menu.Item key="/view/ref_daily_exchange_rates">Daily Exchange Rates</Menu.Item>
                                    <Menu.Item key="/view/ref_per_month_exchange_rates">Month-Last Day Exchange Rates</Menu.Item>
                                    <Menu.Item key="/view/ref_per_monthly_exchange_rates_gbp">Monthly Exchange Rates GBP</Menu.Item>
                                    <Menu.Item key="/view/ref_annual_exchange_rates">Annual Exchange Rates</Menu.Item>
                                    <Menu.Item key="/view/ref_sdr_exchange_rates">SDR Exchange Rates</Menu.Item>
                                    <SubMenu title="Exchange Rates Non EU" mode="vertical">
                                        <Menu.Item key="/view/ref_exchange_rates_norway">Exchange Rates for Norway</Menu.Item>
                                        <Menu.Item key="/view/ref_exchange_rates_uk">Exchange Rates for UK</Menu.Item>
                                        <Menu.Item key="/view/ref_exchange_rates_ch">Exchange Rates for Switzerland</Menu.Item>
                                    </SubMenu>
                                </SubMenu>
                                <SubMenu title="Tax & Duties" mode="vertical" icon={<FundOutlined />}>
                                    <Menu.Item key="/view/ref_country_vat_rate">Vat Rates - EU</Menu.Item>
                                    <Menu.Item key="/view/ref_country_vat_rate_non_eu">Vat Rates - Non EU</Menu.Item>
                                    <Menu.Item key="/view/ref_country_customs_duty_rate">Customs Duty Rates</Menu.Item>
                                    <SubMenu title={"Customs Duty Rates - Non EU"}>
                                        <Menu.Item key="/view/ref_country_customs_duty_rate_non_eu">Customs Duty Rates - Non EU</Menu.Item>
                                        <Menu.Item key="/view/ref_country_groups">Country Groups</Menu.Item>
                                    </SubMenu>
                                    <Menu.Item key="/view/ref_hs6p_code">HS6+ Codes</Menu.Item>
                                    <Menu.Item key="/view/ref_customs">Customs</Menu.Item>
                                    <Menu.Item key="/view/ref_dpo_special_arrangement">DPO Special Arrangements</Menu.Item>
                                    <Menu.Item key="/view/ref_EM_EAS_Intermediary_numbers">EAS OSS Intermediary Numbers</Menu.Item>
                                    <Menu.Item key="/view/ref_historic_country_vat_rate">Historic Country VAT Data</Menu.Item>
                                    <Menu.Item key="/view/ref_special_territory">Special VAT Territories</Menu.Item>
                                </SubMenu>

                                <SubMenu title="EM Fees" mode="vertical" icon={<CreditCardOutlined />}>
                                    <Menu.Item key="/view/ref_fee_class">Fee Classes</Menu.Item>
                                    <Menu.Item key="/view/ref_auto_active_fee_class">Auto Active Fee Classes</Menu.Item>
                                    <Menu.Item key="/view/em-annual-fees">Annual Fees</Menu.Item>
                                    <Menu.Item key="/view/em-reporting-fees">Reporting Fees</Menu.Item>
                                    <Menu.Item key="/view/em-invoicing-fees">Invoicing Fees</Menu.Item>
                                </SubMenu>
                            </SubMenu>

                            <Divider style={{margin: 5}}/>
                            <SubMenu icon={<NodeIndexOutlined />} title="Subcontractors" mode="vertical">
                                <Menu.Item key="/view/ref_hs6p_subcontractors">HS6P</Menu.Item>
                            </SubMenu>
                            <Divider style={{margin: 5}}/>
                            <SubMenu icon={<ToolOutlined />} title="Jobs" mode="vertical">
                                <Menu.Item key="/view/mass_post_sale_log" icon={<FileZipOutlined />}>Mass Post Sale Log</Menu.Item>
                                <Menu.Item key="/view/mass_post_sale_without_lc_log" icon={<HddOutlined />}>Mass Post Sale Without LC Log</Menu.Item>
                            </SubMenu>
                            <Menu.Item key="/view/ref_error_logs" icon={<ExclamationCircleOutlined />}>
                                Error Logs
                            </Menu.Item>
                            <Divider style={{margin: 5}}/>
                            <SubMenu title={"Settings"} mode="vertical" icon={<SettingOutlined/>}>
                                <Menu.Item key={`/view/audit`} icon={<MenuUnfoldOutlined/>}>Audit Trail</Menu.Item>
                                <Menu.Item key={`/view/schedules`} icon={<ScheduleOutlined />}>Schedules</Menu.Item>
                                <Menu.Item key="/view/ref_enumeration" icon={<FileSearchOutlined />}>Enumeration</Menu.Item>
                                <Menu.Item key={`/view/emd_configs`} icon={<PicRightOutlined />}>EM Dashboard Configs</Menu.Item>
                                <SubMenu title={"Notifications"} icon={<NotificationOutlined />}>
                                    <Menu.Item key="/view/ref_eas_error_notification_types">Notification Types</Menu.Item>
                                    <Menu.Item key="/view/ref_notification_subscribers">Notification Subscribers</Menu.Item>
                                    <Menu.Item key="/view/notification_settings">Notification Settings</Menu.Item>
                                </SubMenu>
                                <SubMenu title={"EAS"} icon={<SettingOutlined/>}>
                                    <Menu.Item key="/view/info">EAS Info</Menu.Item>
                                    <Menu.Item key="/view/eas_vat_reg">EAS VAT Registrations</Menu.Item>
                                    <Menu.Item key="/view/invoice_setting">Invoice Settings</Menu.Item>
                                    <Menu.Item key="/view/general_contract_doc">General Contract Documents</Menu.Item>
                                    <Menu.Item key="/view/intermediary_information">Intermediary Information</Menu.Item>
                                </SubMenu>
                            </SubMenu>

                        </Menu>
                    </div>
                </div>

            </Sider>
            <Layout className="site-layout">
                <Content>
                    <Route path="/view/dashboard">
                        <Dashboard/>
                    </Route>
                    <Route path="/view/register">
                        <Register/>
                    </Route>
                    <Route path="/view/invites">
                        <Invitations/>
                    </Route>
                    <Route path="/view/em-info">
                        <EMList/>
                    </Route>
                    <Route path="/view/add-message">
                        <AddMessage/>
                    </Route>
                    <Route path="/view/direct-message">
                        <DirectMessage/>
                    </Route>
                    <Route path="/view/reports">
                        <Reports/>
                    </Route>
                    <Route path="/view/invoice_list_view">
                        <InvoiceListView/>
                    </Route>
                    <Route path="/view/emvat_report_fiscal_view">
                        <EMVATFiscalReportListViewV1/>
                    </Route>
                    <Route path="/view/risk_management">
                        <RiskManagement/>
                    </Route>
                    <Route path="/view/order_info">
                        <OrderInfo/>
                    </Route>
                    <Route path="/view/order_return">
                        <OrderReturn/>
                    </Route>
                    <Route path="/view/order_discount">
                        <OrderDiscount/>
                    </Route>
                    <Route path="/view/ref_country">
                        {/*<RefTable filterSchema={"country_filter"} pagetitle="Countries" feconfig="country"*/}
                        {/*          visualize="country" tablename="country" syncButtonHidden={true} editablility={true}/>*/}
                        <Country/>
                    </Route>
                    <Route path="/view/ref_currency">
                        {/*<RefTable pagetitle="Currencies" feconfig="currency" visualize="currency" tablename="currency"*/}
                        {/*          syncButtonHidden={true} editablility={true}/>*/}
                        <Currency/>
                    </Route>
                    <Route path="/view/ref_daily_exchange_rates">
                        <DailyExchangeRates/>
                    </Route>
                    <Route path="/view/ref_per_month_exchange_rates">
                        <MonthlyLastDayExchangeRates/>
                    </Route>
                    <Route path="/view/ref_per_monthly_exchange_rates_gbp">
                        <MonthlyExchangeRatesGBP/>
                    </Route>
                    <Route path="/view/ref_exchange_rates_norway">
                        <ExchangeRatesNonEU tableName = {'NO'} title = {"Exchange Rates for Norway"}/>
                    </Route>
                    <Route path="/view/ref_exchange_rates_uk">
                        <ExchangeRatesNonEU tableName = {'GB'} title = {"Exchange Rates for United Kingdom"}/>
                    </Route>
                    <Route path="/view/ref_exchange_rates_ch">
                        <ExchangeRatesNonEU tableName = {'CH'} title = {"Exchange Rates for Switzerland"}/>
                    </Route>
                    <Route path="/view/ref_annual_exchange_rates">
                        <AnnualExchangeRates/>
                    </Route>
                    <Route path="/view/ref_sdr_exchange_rates">
                        {/*<RefTable pagetitle="SDR Exchange Rates" feconfig="sdr_exchange_rate"*/}
                        {/*          visualize="sdr_exchange_rate" tablename="sdr_exchange_rate" syncButtonHidden={false}*/}
                        {/*          functioncall={updateSDRRate} editablility={true}/>*/}
                        <SDRExchangeRate/>
                    </Route>
                    <Route path="/view/ref_country_vat_rate">
                        <CountryVatRates/>
                    </Route>
                    <Route path="/view/ref_country_vat_rate_non_eu">
                        {/*<RefTable pagetitle="Non-EU VAT Rates" feconfig="country_vat_rate_non_eu"*/}
                        {/*    visualize="countryvatratesnoneu" tablename="country_vat_rate_non_eu" syncButtonHidden={true}*/}
                        {/*    editablility={true} />*/}
                        <NonEUVatRate/>
                    </Route>
                    <Route path="/view/ref_historic_country_vat_rate">
                        <HistoricCountryVATData/>
                    </Route>
                    <Route path="/view/ref_special_territory">
                        <SpecialTerritories/>
                    </Route>
                    <Route path="/view/ref_country_customs_duty_rate">
                        <CustomsDutyRates/>
                    </Route>
                    <Route path="/view/ref_country_customs_duty_rate_non_eu">
                        <CustomsDutyRatesNonEU/>
                    </Route>
                    <Route path="/view/ref_country_groups">
                        <CountryGroups/>
                    </Route>
                    <Route path="/view/ref_hs6p_code">
                        <HS6P/>
                    </Route>
                    <Route path="/view/gdpr_documents">
                        <GDPRDocuments/>
                    </Route>
                    <Route path="/view/data_security_agreements">
                        <ReportingDataSecurityAgreements/>
                    </Route>
                    <Route path="/view/ref_enumeration">
                        <Enum/>
                    </Route>
                    <Route path="/view/emd_configs">
                        <EMDashboardCobrand/>
                    </Route>
                    <Route path="/view/eas_vat_reg">
                        {/*<RefTable pagetitle="EAS VAT Registrations" feconfig="eas_vat_reg_info" visualize="eas_vat_reg_info" tablename="eas_vat_reg_info"*/}
                        {/*          syncButtonHidden={true} editablility={true}/>*/}
                        <VatRegistration/>
                    </Route>
                    <Route path="/view/info">
                        <Info/>
                    </Route>
                    <Route path="/view/audit">
                        <PaginatedAuditTrail/>
                    </Route>
                    <Route path="/view/schedules">
                        <Schedules/>
                    </Route>
                    <Route path="/view/ref_checkouts">
                        {/*<RefTable pagetitle="Checkouts" feconfig="checkouts" visualize="checkouts" tablename="checkout"*/}
                        {/*          syncButtonHidden={true} editablility={true}/>*/}
                        <Checkout/>
                    </Route>
                    <Route path="/view/ref_courier">
                        {/*<RefTable pagetitle="Couriers" feconfig="ref_couriers" visualize="courier" tablename="courier"/>*/}
                        <Courier/>
                    </Route>
                    <Route path="/view/ref_fee_class">
                        <FeeClasses/>
                    </Route>
                    <Route path="/view/ref_auto_active_fee_class">
                        {/*<RefTable pagetitle="Auto Active Fee Classes" feconfig="fee_classes_auto_active" visualize="fee_classes_auto_active"*/}
                        {/*          tablename="fee_classes_auto_active" syncButtonHidden={true} addRecordButtonHidden={true}/>*/}
                        <AutoActiveFeeClasses/>
                    </Route>
                    <Route path="/view/ref_sales_type">
                        {/*<RefTable pagetitle="Sales Types" feconfig="sales_type" visualize="sales_type"*/}
                        {/*          tablename="sales_type" syncButtonHidden={true}/>*/}
                        <SalesType/>
                    </Route>
                    <Route path="/view/registration_requests">
                        <ApplicationView/>
                    </Route>
                    <Route path="/view/ref_po">
                        <PostalOperator/>
                    </Route>
                    <Route path="/view/ref_customs">
                        <Customs/>
                    </Route>
                    <Route path="/view/ref_dpo_special_arrangement">
                        <DPOSpecialArrangement/>
                    </Route>
                    <Route path="/view/ref_hs6p_subcontractors">
                        <HS6PSubcontractorInfo/>
                    </Route>
                    < Route path="/view/import_vat_corrections">
                        <EMVATFiscalCorrection title="Import VAT Corrections" tableSchema={VATCorrectionTable.OSS_IMPORT}
                                               tableName={VATCorrectionTableSchema.OSS_IMPORT} filterSchema={`${VATCorrectionTable.OSS_IMPORT}_filter`} />
                    </Route>
                    < Route path="/view/non_eu_import_vat_corrections">
                        <EMVATFiscalCorrection title="Non EU Import VAT Corrections" tableSchema={VATCorrectionTable.OSS_NON_EU_IMPORT}
                                               tableName={VATCorrectionTableSchema.OSS_NON_EU_IMPORT} filterSchema={`${VATCorrectionTable.OSS_NON_EU_IMPORT}_filter`} />
                    </Route>
                    < Route path="/view/non_union_vat_corrections">
                        <EMVATFiscalCorrection title="Non Union VAT Corrections" tableName={VATCorrectionTableSchema.OSS_NON_UNION}
                                               tableSchema={VATCorrectionTable.OSS_NON_UNION} filterSchema={`${VATCorrectionTable.OSS_NON_UNION}_filter`}/>
                    </Route>
                    < Route path="/view/union_vat_corrections">
                        <EMVATFiscalCorrection title="Union VAT Corrections" tableName={VATCorrectionTableSchema.OSS_UNION}
                                               tableSchema={VATCorrectionTable.OSS_UNION} filterSchema={`${VATCorrectionTable.OSS_UNION}_filter`}/>
                    </Route>
                    <Route path="/view/em-annual-fees">
                        {/*<RefTable pagetitle="Annual Fees" feconfig="em_annual_fee_type" visualize="em_annual_fee_type"*/}
                        {/*          tablename="em_annual_fee_type" syncButtonHidden={true} addRecordButtonHidden={false}*/}
                        {/*          editablility={true}/>*/}
                        <AnnualFees/>
                    </Route>
                    <Route path="/view/em-reporting-fees">
                        {/*<RefTable pagetitle="Reporting Fees" feconfig="em_reporting_fee_type"*/}
                        {/*          visualize="em_reporting_fee_type" tablename="em_reporting_fee_type"*/}
                        {/*          syncButtonHidden={true} addRecordButtonHidden={false} editablility={true}/>*/}
                        <ReportingFeeClasses/>
                    </Route>
                    <Route path="/view/em-invoicing-fees">
                        {/*<RefTable pagetitle="Invoicing Fees" feconfig="em_invoicing_fee_type"*/}
                        {/*          visualize="em_invoicing_fee_type" tablename="em_invoicing_fee_type"*/}
                        {/*          syncButtonHidden={true} addRecordButtonHidden={false} editablility={true}/>*/}
                        <InvoicingFees/>
                    </Route>
                    <Route path="/view/ref_EM_EAS_Intermediary_numbers">
                        {/*<RefTable pagetitle="EAS OSS Intermediary Numbers" feconfig="eas_oss_intermediary_number"*/}
                        {/*          visualize="eas_oss_intermediary_number" tablename="eas_oss_intermediary_number"*/}
                        {/*          syncButtonHidden={true} addRecordButtonHidden={true} editablility={false}/>*/}
                        <EASOSSIntermediaryNumbers/>
                    </Route>
                    <Route path="/view/em_platform">
                        {/*<RefTable pagetitle="Integration Platforms" feconfig="em_platform" visualize="em_platform"*/}
                        {/*          tablename="em_platform" syncButtonHidden={true} addRecordButtonHidden={false}*/}
                        {/*          editablility={true}/>*/}
                        <EMPlatform/>
                    </Route>
                    <Route path="/view/user_management/operator">
                        <OperatorUserManagement/>
                    </Route>
                    <Route path="/view/mass_post_sale_log">
                        <MassPostSaleLog/>
                    </Route>
                    <Route path="/view/mass_post_sale_without_lc_log">
                        <MassPostSaleWithoutLC/>
                    </Route>
                    <Route path="/view/invoice_setting">
                        <InvoiceSettings />
                    </Route>
                    <Route path="/view/ref_eas_error_notification_types">
                        <NotificationTypes />
                    </Route>
                    <Route path="/view/ref_notification_subscribers">
                        <NotificationSubscribers/>
                    </Route>
                    <Route path="/view/ref_error_logs">
                        <ErrorLogs/>
                    </Route>
                    <Route path="/view/general_contract_doc">
                        <GeneralContractDocuments />
                    </Route>
                    <Route path="/view/intermediary_information">
                        <IntermediaryInformation />
                    </Route>
                    <Route path="/view/notification_settings">
                        <NotificationSettings />
                    </Route>
                </Content>
                <Layout.Footer className="footer">
                    <Typography.Text italic disabled>{`© 2026 EAS Project Oy. Operator Frontend Build`}</Typography.Text>
                </Layout.Footer>
            </Layout>
        </Layout>
    </React.Fragment>
};


const MainView = withAuthentication(MainViewImpl, {signInView: LandingView})

export default MainView;
